import { get } from 'lodash';
import { extractButton } from '../../utils/elements';
import { getButtonMaxWidth, getButtonMinWidth } from '../../utils/button-utils';
export const getButton = ({ region, css, isRtl = false, experiments = {}, mixData, columnWidthPx, }) => {
    const buttonStyles = get(region, 'data.styles.main') || {};
    const defaultStyles = css['so-global-b1-mix'];
    const maxWidth = getButtonMaxWidth(defaultStyles, '300px', columnWidthPx);
    const minWidth = getButtonMinWidth(buttonStyles, defaultStyles, '140px', columnWidthPx);
    const minCalculatedColumnWidth = Math.min.apply(null, [...mixData.data.layout.rows[0].columns].map((col) => col.width));
    const button = extractButton({
        customStyles: buttonStyles,
        defaultStyles,
        experiments,
        isRtl,
        region,
        minCalculatedColumnWidth: minCalculatedColumnWidth,
    });
    return {
        button,
        regionId: region.regionId,
        type: 'button',
        minWidth: `${minWidth}px`,
        maxWidth: `${maxWidth}px`,
    };
};
//# sourceMappingURL=get-button.js.map